import { render, staticRenderFns } from "./Index-Registers.vue?vue&type=template&id=32df44e4"
import script from "./Index-Registers.vue?vue&type=script&lang=js"
export * from "./Index-Registers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports